<template>
    <div>
            <b-card>
                <b-row class="mb-1">
                    <b-col lg="4">
                    </b-col>
                    <b-col lg="8" class="d-flex justify-content-end align-items-center">
                      <template v-if="$permissionAbility(COUPON_CREATE, permissions)">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            class="flex-shrink-0"
                            variant="primary"
                            @click="showCouponModal"
                        >
                            Create Coupon
                        </b-button>

                      </template>
                    
                    </b-col>
                </b-row>
            <!-- table -->
            <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :is-loading.sync="isLoading"
                :rows="rows"
                :sort-options="{
                enabled: false,
                multipleColumns: true,
                initialSortBy: [
                    { field: 'id', type: 'desc' },
                    { field: 'name', type: 'desc' },
                    { field: 'created_at', type: 'desc' },
                ],
                }"
                :columns="columns"
                :pagination-options="{
                enabled: true,
                perPage: pageLength,
                }"
                style-class="vgt-table striped"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
                <template
                slot="table-row"
                slot-scope="props"
                >

                <span v-if="props.column.field === 'sl'">
                  {{
                    (serverParams.page - 1) * serverParams.perPage + props.index + 1
                  }}
                </span>
               
                <span v-if="props.column.field === 'status_design'">
                  <span
                    v-if="props.row.status === 'active'"
                    class="badge bg-success"
                  >
                    Active
                  </span>
                  <span
                    v-else-if="props.row.status === 'inactive'"
                    class="badge bg-danger"
                  >
                    Inactive
                  </span>
                </span>

                <span v-if="props.column.field === 'created_at_formated'">
                  {{
                    new Date(props.row.created_at).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    })
                  }}
                </span>


                <span v-if="props.column.field === 'action'">
                  <template v-if="$permissionAbility(COUPON_EDIT, permissions)">
                    <span @click="onShow(props.row)">
                        <feather-icon
                            v-b-tooltip.hover
                            icon="Edit2Icon"
                            class="mr-50 custom-icon cursor-pointer"
                            title="Edit"
                            size="16"
                        />
                    </span>
                  </template>
                  <template v-if="$permissionAbility(COUPON_DELETE, permissions)">
                    <span>
                        <feather-icon @click="onDelete(props.row)"
                            v-b-tooltip.hover
                            icon="Trash2Icon"
                            class="mr-50 custom-icon cursor-pointer"
                            title="Delete"
                            size="16"
                        />
                    </span>
                  </template>
                </span>
        
                <!-- Column: Common -->
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
                </template>
        
                <!-- pagination -->
                <template
                slot="pagination-bottom"
                slot-scope="props"
                >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                        v-model="pageLength"
                        :options="['10', '25', '50', '100', '500']"
                        class="mx-1"
                        @input="
                        (value) => props.perPageChanged({ currentPerPage: value })
                        "
                    />
                    <span class="text-nowrap"> of {{ props.total }} entries </span>
                    </div>
                    <div>
                    <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                    >
                        <template #prev-text>
                        <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                        />
                        </template>
                        <template #next-text>
                        <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                        />
                        </template>
                    </b-pagination>
                    </div>
                </div>
                </template>
            </vue-good-table>
            </b-card>
    
        <b-modal
          id="modal-coupon-model"
          centered
          :title="modelType === 'editModel' ? 'Edit Mail Template' : 'Create Coupon'"
          hide-footer
          no-close-on-backdrop
          @hidden="hiddenCouponModal"
          size="lg"
        >
          <validation-observer ref="couponCreate">
            <b-form @submit.prevent="validCouponCreate">

              <!-- Code -->
              <b-form-group label="Code" label-for="code" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  type="text"
                  name="Code"
                  vid="code"
                  rules="required|max:255"
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Type -->
              <b-form-group label="Type" label-for="type" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="Type"
                  vid="type"
                  rules="required"
                >
                  <b-form-select
                    id="type"
                    v-model="type"
                    :options="typeOptions"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Select Type"
                  >
                <template #first>
                  <option value="" disabled>Select Type</option>
                </template>
                </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Value -->
              <b-form-group label="Value" label-for="value" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="Value"
                  vid="value"
                  rules="required|numeric|min:0"
                >
                  <b-form-input
                    id="value"
                    v-model="value"
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Value"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Usage Limit" label-for="usage_limit" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="Usage Limit"
                  vid="usage_limit"
                  rules="required|numeric|min:0"
                >
                  <b-form-input
                    id="usage_limit"
                    v-model="usage_limit"
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Usage Limit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Start Date -->
              <b-form-group label="Start Date" label-for="start_date" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="Start Date"
                  vid="start_date"
                  rules="required"
                >
                  <b-form-datepicker
                    id="start_date"
                    v-model="start_date"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Select Start Date"
                  ></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- End Date -->
              <b-form-group label="End Date" label-for="end_date" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="End Date"
                  vid="end_date"
                  rules="required"
                >
                  <b-form-datepicker
                    id="end_date"
                    v-model="end_date"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Select End Date"
                  ></b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Status -->
              <b-form-group label="Status" label-for="status" class="required-label">
                <validation-provider
                  #default="{ errors }"
                  name="Status"
                  vid="status"
                  rules="required"
                >
                  <b-form-select
                    id="status"
                    v-model="status"
                    :options="statusOptions"
                    :state="errors.length > 0 ? false : null"
                  >
                <template #first>
                  <option value="" disabled>Select Type</option>
                </template>
                </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Loading / Submit button -->
              <template v-if="isCouponFromSubmitLoading">
                <b-button class="float-right" variant="primary" disabled>
                  <b-spinner small />
                  Loading...
                </b-button>
              </template>
              <template v-else>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  class="float-right"
                  variant="primary"
                >
                  Submit
                </b-button>
              </template>
            </b-form>
          </validation-observer>
        </b-modal>

    </div>
  </template>
  
  <script>
  import flatPickr from 'vue-flatpickr-component'
  import {
    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BForm,
    BModal,
    BSpinner,
    BFormDatepicker,
    BLink, VBTooltip, BRow, BCol, BFormTextarea,
    BFormCheckbox,
  } from 'bootstrap-vue'
  import { VueGoodTable } from 'vue-good-table'
  import Ripple from 'vue-ripple-directive'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required, max } from "@validations";
  import { quillEditor } from "vue-quill-editor";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import UserCard from '@/layouts/components/UserCard.vue'
  import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapGetters } from 'vuex'
  import {
  COUPON_DELETE,
  COUPON_CREATE,
  COUPON_EDIT,
} from '@/helpers/superAdminPermissionConstant'

  export default {
    name: 'CompanyRequestView',
    components: {
      BFormTextarea,
      BCol,
      BRow,
      BForm,
      BButton,
      BCard,
      VueGoodTable,
      BAvatar,
      BBadge,
      BPagination,
      BFormGroup,
      BFormInput,
      BFormSelect,
      BDropdown,
      BDropdownItem,
      ValidationProvider,
      ValidationObserver,
      BModal,
      BSpinner,
      BLink,
      quillEditor,
      UserCard,
      BCardActions,
      BFormDatepicker,
      flatPickr,
      BFormCheckbox,
    },
    directives: {
      Ripple,
      'b-tooltip': VBTooltip,
    },
    data() {
      return {
        COUPON_CREATE,
        COUPON_EDIT,
        COUPON_DELETE,
        code: '',
        type: '',
        value: '',
        start_date: null,
        end_date: null,
        status: 1, // default active
        modelType: '',
        isCouponFromSubmitLoading: false,
        typeOptions: [
          { value: 'percentage', text: 'Percentage' },
          { value: 'flat', text: 'Flat' },
        ],
        statusOptions: [
          { value: 1, text: 'Active' },
          { value: 2, text: 'Inactive' },
        ],
        usage_limit: null,
        pageLength: 10,
        columns: [
          {
            label: 'SL',
            field: 'sl',
          },
          {
            label: 'Code',
            field: 'code',
          },
          {
            label: 'Type',
            field: 'type',
          },
          {
            label: 'Value',
            field: 'value',
          },
          {
            label: 'Start Date',
            field: 'start_date',
          },
          {
            label: 'End Date',
            field: 'end_date',
          },
          {
            label: 'Usage Limit',
            field: 'usage_limit',
          },
          {
            label: 'Status',
            field: 'status_design',
          },
          {
            label: 'CreatedAt',
            field: 'created_at_formated',
          },
          {
            label: 'Action',
            field: 'action',
            sortable: false,
          },
        ],
        rows: [],
        searchTerm: '',
        delayTimer: null,
        isLoading: false,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            { field: 'id', type: 'desc' },
            { field: 'name', type: 'desc' },
          ],
          page: 1,
          perPage: 10,
        },
        couponId: null,
      }
    },
  
  computed: {
    ...mapGetters({
      permissions: 'superAdminAuthModule/getPermissions',
    }),
  },
    methods: {
      onSearch() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer)
          this.delayTimer = null
        }
  
        this.delayTimer = setTimeout(() => {
          this.loadItems()
        }, 1000)
      },
      showCouponModal() {
        this.$bvModal.show("modal-coupon-model");
      },
  
      hiddenCouponModal() {
        this.$bvModal.hide("modal-coupon-model");
        this.resetCouponModal();
      },
  
      async onShow(value) {
      
      this.modelType = "editModel";
      this.code = value.code;
      this.type = value.type;
      this.value = Number(value.value);
      this.couponId = value.id;
      this.start_date = value.start_date;
      this.end_date = value.end_date;
      this.status = value.actual_status;
      this.usage_limit = value.usage_limit;

      this.showCouponModal();
    },
      resetCouponModal() {
        this.code = ""
        this.type = ""
        this.value = ""
        this.start_date = ""
        this.end_date = ""
        this.status = ""
      },

      updateParams(newProps) {
        this.serverParams = { ...this.serverParams, ...newProps }
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage })
        this.loadItems()
      },
  
      onPerPageChange(params) {
        this.updateParams({ perPage: params.currentPerPage })
        this.loadItems()
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: params,
        })
        this.loadItems()
      },
  
      onColumnFilter(params) {
        this.updateParams(params)
        this.loadItems()
      },
      async onDelete(row) {
      const { id, code } = row;
      this.$swal({
        title: "Warning!",
        text: `Are You Sure You Want To Delete ${code}?`,
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await this.$api.delete(`/api/super-admin/coupon/${id}`);

            this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: response.data.message,
              },
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },
      async validCouponCreate() {
        this.$refs.couponCreate.validate().then(async (success) => {
          if (success) {
            try { 
              
                this.isCouponFromSubmitLoading = true;
                let formData = {
                    code: this.code,
                    type: this.type,
                    value: this.value,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    status: this.status,
                    value: this.value,
                    usage_limit: this.usage_limit
                };
                let response;
                if (this.modelType === 'editModel') {
                    response = await this.$api.put(
                    `/api/super-admin/coupon/${this.couponId}`,
                    formData,
                    );
                } else {
                    response = await this.$api.post(
                    "/api/super-admin/coupon",
                    formData,
                    );
                }
                
                this.isCouponFromSubmitLoading = false;
                this.hiddenCouponModal();
  
                this.loadItems();
  
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: response?.data?.message,
                  },
                });
            } catch (error) {
              this.isCouponFromSubmitLoading = false;
  
              if (error?.response?.data?.message) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    icon: "BellIcon",
                    variant: "danger",
                    text: error?.response?.data?.message,
                  },
                });
              }
  
              if (error?.response?.data?.errors) {
                this.$refs.companyValidation.setErrors(
                  error?.response?.data?.errors
                );
              }
            }
          }
        });
      },
  
      async getCoupons(params) {
        return await this.$api.get('api/super-admin/coupon', {
          params: {
            show: params.show,
            page: params.page,
            sort: params.sort,
          },
        })
      },
  
      async loadItems() {
        try {
          const [mailTemplate] = await Promise.all([
            this.getCoupons({
              show: this.serverParams.perPage,
              page: this.serverParams.page,
              sort: this.serverParams.sort,
            }),
          ])
  
          const data = mailTemplate?.data?.data
          const meta = mailTemplate?.data?.meta

          this.totalRecords = meta?.pagination?.total
          this.rows = data
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Warning',
              icon: 'BellIcon',
              variant: 'warning',
              text: error?.response?.data?.message,
            },
          })
        }
      },
    
    },
  }
  </script>
  
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-good-table.scss";
  @import "@core/scss/vue/libs/quill.scss";
  @import '@core/scss/vue/libs/vue-flatpicker';
  </style>
  